import { createContext, useContext } from "react";

import type { AutocompleteProps } from "./Autocomplete.types";

export type AutocompleteContextValue = Pick<AutocompleteProps, "size">;

export function makeAutocompleteContext({
  size = "md",
}: Partial<AutocompleteContextValue>): Required<AutocompleteContextValue> {
  return { size };
}

export const AutocompleteContext = createContext<
  Required<AutocompleteContextValue>
>(makeAutocompleteContext({}));

export function useAutocompleteContext() {
  return useContext(AutocompleteContext);
}
